import MiniMasonry from "minimasonry";

export const initMasonry = () => {
  if (document.querySelector(".masonary-grid") !== null) {
    var masonaryDefault = new MiniMasonry({
      container: document.querySelector(".masonary-grid"),
      gutter: 40,
      basewidth: 350,
      surroundingGutter: false,
    });
  }
};
